import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { downgradeToAJSComponent } from 'ib-web-commons/utils';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { ICategory, ITabsModel } from "@src/components/ib-MmB-gastronomic-proposal/models/digital-menu.model";

@Component({
    selector: 'ib-digital-menu-content',
    templateUrl: './ib-digital-menu-content.component.html',
    styleUrls: ['./ib-digital-menu-content.component.scss']
})

export class IbDigitalMenuContentComponent implements OnInit {

    tabs: ITabsModel = {
        generals: [],
        others: []
    }

    @Input() categories: ICategory[] = [];
    @Input() disclaimer: string;
    @Input() expressMenu!: string;

    @ViewChild('navTabs') navTabs: NgbNav;

    constructor() { }

    ngOnInit(): void {
        this.setTabs();
    }

    isOtherTabSelected(): boolean {
        const tabSelected = this.navTabs ? this.navTabs.activeId : 2;
        return tabSelected === 2 || tabSelected === 3 || tabSelected === 4;
    }

    getOtherTabSelectedName(): string {
        const tabSelected = this.navTabs ? this.navTabs.activeId : 0;
        return this.categories[tabSelected] ? this.categories[tabSelected].name : '';
    }

    private setTabs() {
        if (this.categories.length > 3) {
            this.tabs.generals = this.categories.slice(0, 2);
            this.tabs.others = this.categories.slice(2);
        } else {
            this.tabs.generals = [...this.categories];
        }
    }
}

downgradeToAJSComponent('ibDigitalMenuContent', {
    component: IbDigitalMenuContentComponent,
    inputs: ['categories', 'disclaimer', 'expressMenu']
}, 'ib-MmB-gastronomic-proposal-module');
